import * as React from 'react';

import Button from '@mui/material/Button';

import { useNavigate } from 'react-router-dom';

import AuthLayout, { primaryButtonSx } from './auth/AuthLayout';

const VerificationSuccess = () => {
    const navigate = useNavigate();
    return (
        <AuthLayout title="Verificación exitosa" subtitle="Ya puedes ingresar a la solución">
            <Button fullWidth variant="contained" sx={primaryButtonSx} onClick={() => navigate('/admin')}>
                Ingresar
            </Button>
        </AuthLayout>
    );
};

export default VerificationSuccess;
